import '@expo/metro-runtime';
import DeviceOrientation, { Orientation } from 'react-screen-orientation';
import { View, StyleSheet, Text } from 'react-native';

import { registerRootComponent } from 'expo';

import { LoadSkiaWeb } from '@shopify/react-native-skia/lib/module/web';
import App from './App';
import PleaseRotateImage from './components/PleaseRotateImage';
import Colors from './constants/Colors';
import isMobile from './components/IsMobile';

const OrientedApp = () => <>
  <DeviceOrientation lockOrientation='portrait'>
    <Orientation orientation='landscape' alwaysRender={false}>
      <View style={styles.fullScreen}>
        <>
          <PleaseRotateImage />
          <Text style={styles.title}>{'Please rotate your device'}</Text>
          <Text>{'We don\'t support landscape mode yet.'}</Text>
          <Text>{'Please go back to portrait mode for the best experience'}</Text>
        </>
      </View>
    </Orientation>
  </DeviceOrientation>
  <App />
</>;

const styles = StyleSheet.create({
  fullScreen: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 2,
    backgroundColor: '#FFF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: 20,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksLoading,
    textAlign: 'center',
    marginBottom: 13,
  },
  subtitle: {
    fontSize: 15,
    lineHeight: 20,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksPrimaryGrey800,
    textAlign: 'center',
  },
});

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
LoadSkiaWeb({
  locateFile: (file) => `/${file}`
}).then(async () => {
  registerRootComponent(isMobile ? OrientedApp : App);
});

// registerRootComponent(isMobile ? OrientedApp : App);
